'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@common/components';
import { Fragment } from 'react';
import { TABS } from '../constants';
interface TabDeliveryProps {
  deliveryFee: number;
  deliveryCompanyName: string;
}
export const TabDelivery = t0 => {
  const $ = _c(15);
  const {
    deliveryFee,
    deliveryCompanyName
  } = t0;
  const t1 = deliveryCompanyName || "\uD0DD\uBC30";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      label: "\uBC30\uC1A1\uBC29\uBC95",
      value: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      label: "\uBC30\uC1A1 \uC9C0\uC5ED",
      value: "\uC804\uAD6D"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== deliveryFee) {
    t4 = deliveryFee === 0 ? "\uBB34\uB8CC" : `${deliveryFee.toLocaleString()}원`;
    $[3] = deliveryFee;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = {
      label: "\uBC30\uC1A1\uBE44",
      value: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      label: "\uBC30\uC1A1 \uAE30\uAC04",
      value: "\uACB0\uC81C\uC77C\uB85C\uBD80\uD130 2~7\uC77C \uC774\uB0B4 \uBC30\uC1A1"
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t5) {
    t7 = [t2, t3, t5, t6];
    $[8] = t2;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const deliveryItems = t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h3 className="font-700 text-Gray-900 typo-h5">구매/배송</h3>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="font-400 text-Gray-600 typo-body3">주문하신 상품은 3일 이내에 출고가 시작될 예정입니다.<br />물류 상황에 따라 배송이 지연될 수 있어요. 양해 부탁드려요.</p>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== deliveryItems) {
    t10 = <section id={TABS.DELIVERY}><div className="flex flex-col gap-16 px-20">{t8}{t9}<div className="flex flex-col gap-12">{deliveryItems.map((item, index) => <Fragment key={item.label}><div className="flex flex-col gap-4"><span className="w-100 font-400 text-Gray-600 typo-body3">{item.label}</span><span className="font-400 text-Gray-900 typo-body3">{item.value}</span></div>{index < deliveryItems.length - 1 && <Divider />}</Fragment>)}</div></div></section>;
    $[13] = deliveryItems;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};